import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"
import findDocument from "cc-frontend/helpers/find-document"
import _ from "lodash"

export default class AdminUserSessions extends Component {
  @service("ember-store")
  store

  @service
  rpc

  @service
  query

  results = []
  sessionsQuery = null
  selectedActionId = null
  nextOffset = 0

  @findDocument("selectedSessionId", "session") selectedSession

  @findDocument("selectedActionId", "action") selectedAction

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments)
    if (get(this, "model.id") && get(this, "sessionsQuery") === null) {
      let queryId = get(this, "model.id")
      let sessionsQuery = get(this, "query").generateLiveQuery("sessions_for_user", queryId, () => {
        this.fetchQuery()
      })
      set(this, "sessionsQuery", sessionsQuery)
      scheduleOnce("afterRender", () => this.fetchQuery())
    }
  }

  fetchQuery() {
    if (get(this, "nextOffset") === null) return
    set(this, "isFetchingQuery", true)
    get(this, "query")
      .fetch(get(this, "sessionsQuery"), get(this, "nextOffset"), 200)
      .then((response) => {
        if (this.isDestroyed || this.isDestroying) return
        if (this.error) return
        if (response.data === undefined) return

        let data = response.data
        let meta = response.meta || {}

        set(this, "nextOffset", meta.nextOffset)

        let groupedData = _.chain(data.results)
          .groupBy((datum) => {
            return datum.meta.dateString ? datum.meta.dateString.slice(0, 10) : "Undated"
          })
          .map((dates, date) => {
            return [{ dateString: date }, dates]
          })
          .flattenDeep()
          .value()

        if (get(this, "selectedSessionId") === null) {
          set(this, "selectedSessionId", data.results[0].id)
        }
        set(this, "results", get(this, "results").concat(groupedData))
        set(this, "isFetchingQuery", false)
      })
  }

  @action
  selectSession(id) {
    set(this, "selectedSessionId", id)
  }

  @action
  selectAction(id) {
    set(this, "selectedActionId", id)
  }

  @action
  loadMoreBelow() {
    this.fetchQuery()
  }
}
